import { useGlobalStore } from "@/stores/global";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook("i18n:beforeLocaleSwitch", async ({ oldLocale, newLocale, initialSetup, context }) => {
    if (initialSetup) return;
    await useGlobalStore().registerGlobalData(newLocale);
  });
});
